export default "__VITE_ASSET__PpcrmFv2__"